
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPartlycloudyDay as ObiPartlycloudyDayElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-partlycloudy-day.js';
 
 
 

 
 export const ObiPartlycloudyDay = createComponent({
   react: React,
   tagName: 'obi-partlycloudy-day',
   elementClass: ObiPartlycloudyDayElement,
   events: {
     
   }
  });
 
 